import { LogLevels, createConsola } from 'consola/browser'
import type { ConsolaReporter, LogObject } from 'consola'

// loglevel:
//  * warn|error => all
//  * info: only in issue report
//  * debug: only on dev


function stringify(v: any) {
    if (typeof v === 'object') {
        try {
            return JSON.stringify(v, (key, value) => (key.toLowerCase().indexOf('password') !== -1) ? '***' : value)
        } catch (e: any) {
            return 'object_not_serializable'
        }
    } else {
        return v
    }
}

function translateLogLevel(lvl?: number) {
    if (!lvl) return 'error'
    if (lvl < 0) return 'silent'
    if (lvl === 1) return 'warn'
    if (lvl === 2) return 'log'
    if (lvl === 3) return 'info'
    if (lvl === 4) return 'debug'
    if (lvl === 5) return 'trace'
    return 'verbose'
}

const FORMAT_DATETIME = new Intl.DateTimeFormat('fr-FR', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })

class IssueReport implements ConsolaReporter {
    logs = [] as string[]

    public log(logObj: LogObject): void {
        if (logObj && logObj.level <= LogLevels.info)
            this.logs.push(`${FORMAT_DATETIME.format(logObj.date)} [${translateLogLevel(logObj.level)}] ${logObj.args.map(stringify).join(' ')}`)
    }

    reset() {
        this.logs = []
    }
}

export const issueReport = new IssueReport()

export let maxLogLevel = LogLevels.warn

export default defineNuxtPlugin(nuxtApp => {
    if (import.meta.client) {

        nuxtApp.vueApp.config.errorHandler = (error, instance, info) =>
            console.error(instance?.$options?.name || (instance as any)?._?.type?.__file || instance, info, error)
        nuxtApp.hook('vue:error', nuxtApp.vueApp.config.errorHandler)

        const config = useRuntimeConfig().public
        maxLogLevel = config.logLevel ?? LogLevels.warn

        const logger = createConsola({ level: LogLevels.trace })
        logger.addReporter(issueReport)
        if (config.logSkipWrap !== true) logger.wrapAll()
        logger.level = maxLogLevel

        return { provide: { logger } }
    }
})